const mEditionBillingMyPaymentsBillingData = {
  mEditionBillingMyPaymentsBillingData: {
    alerts: {
      updateUsuario: {
        error: 'Un error ha ocurrido. Verifica los datos ingresados y vuelve a intentarlo.',
        success: 'Tus datos de facturación se actualizaron exitosamente.'
      }
    },

    checkFacturaCompleta: '¿Necesitas factura completa?',
    checkFactura: '¿Necesitas Factura A?',

    inputs: {
      cod_postal: {
        label: 'Código Postal',
        placeholder: 'código postal'
      },

      documento_tipo: {
        label: 'Tipo de Documento'
      },

      documento_numero: {
        label: 'Número de Documento',
        message: '* De 3 a 30 caracteres'
      },

      fisica: {
        label: 'Tipo de Persona'
      },

      localidad: {
        label: 'Localidad',
        placeholder: 'localidad'
      },

      linea1: {
        label: 'Dirección Principal',
        placeholder: 'Mi Dirección'
      },

      linea2: {
        label: 'Dirección Opcional'
      },

      movil: {
        label: 'Número de Móvil'
      },

      pais: {
        label: 'País'
      },

      provincia: {
        label: 'Provincia'
      },

      razon_social: {
        labelBusiness: 'Razón Social',
        labelName: 'Nombre',
        message: '* De 3 a 150 caracteres',
        placeholder: 'Mi nombre'
      },

      telefono: {
        label: 'Número de Teléfono'
      }
    },

    validation: {
      cod_postal: {
        required: 'Codigo Postal es requerido. De 1 a 10 caracteres.'
      },
      documento_numero: {
        maxLength: 'La longitud máxima permitida es de 30 caracteres.',
        minLength: 'La longitud mínima permitida es de 3 caracteres.',
        required: 'Número de Documento es requerido. De 3 a 30 caracteres.'
      },

      fisica: {
        required: 'Tipo de Persona es requerido.'
      },

      linea1: {
        required: 'Direccion es requerida. De 1 a 120 caracteres.'
      },

      localidad: {
        required: 'Localidad es requerida. De 1 a 60 caracteres.'
      },

      movil: {
        required: 'Número de Móvil o Telefono es requerido.'
      },

      razon_social: {
        maxLength: 'La longitud máxima permitida es de 150 caracteres.',
        minLength: 'La longitud mínima permitida es de 3 caracteres.',
        required: 'Dato requerido. De 3 a 150 caracteres.'
      },

      telefono: {
        required: 'Número de Teléfono o Movil es requerido.'
      },

      pais: {
        required: 'País es requerido.'
      },

      provincia: {
        required: 'Provincia es requerida.'
      },

      documento_tipo: {
        required: 'Tipo de Documento es requerido.'
      }
    }
  }
}
export default mEditionBillingMyPaymentsBillingData
